import { useEffect, useState } from 'react';
import { ReactPdfViewer } from '../../../../components/ReactPdfViewer/ReactPdfViewer';

import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';

type PreviewProps = {
    pdfUrl: string,
    isLoading: boolean,
    handleNextStep: () => void
}
function Preview(props: PreviewProps) {

    const {
        pdfUrl="",
        isLoading,
        handleNextStep
    } = props;

    const [isAgreed, setAgreed] = useState<boolean>(false);


    return (
        <>
            <div className="w-full overflow-auto" style={{ height: "calc(100% - 84px)", maxHeight: "calc(100% - 84px)" }}>
                {
                   !isLoading ? (
                    <ReactPdfViewer fileUrl={pdfUrl} isModal={false} />
                   ) : null
                }
            </div>
            <div className="bg-white pt-5 pb-4 px-5 flex justify-content-between">
                <div className="flex align-items-center gap-2">
                    <Checkbox
                        inputId="agreed"
                        value={isAgreed}
                        checked={isAgreed}
                        disabled={isLoading}
                        onChange={() => setAgreed(prev => !prev)} />

                    <label htmlFor="agreed">
                    I confirm that this form is accurate and ready for submission to the IRS, subject to the Terms.
                    </label>
                </div>
                <Button label="Next"
                    disabled={!isAgreed || isLoading}
                    onClick={handleNextStep} />
            </div>
        </>
    );
}

export default Preview;
